"use client";
import { MinimalVideoSkin as MinimalVideoSkin$1 } from "../../internal/skins/minimal-video/skin.js";
import { jsx } from "react/jsx-runtime";
//#region src/presets/video/minimal-skin.tsx
function MinimalVideoSkin(props) {
	return /* @__PURE__ */ jsx(MinimalVideoSkin$1, { ...props });
}
//#endregion
export { MinimalVideoSkin };

//# sourceMappingURL=minimal-skin.js.map